import { createAction } from "@reduxjs/toolkit";

export const logoutUser = createAction("users/logoutUser");
